module.exports = __webpack_public_path__ + "img/popup-btn1.4549d859.png";